import React from "react";
import tw from "tailwind-styled-components";
import { SecondaryText } from "@components";
import rightView from "@assets/image/rightView.png";
import rightIcon from "@assets/image/rightIcon.png";

function CourseBtn(props) {
  const { onClick, children, select } = props;
  return (
    <Container onClick={onClick}>
      <SecondaryText className={"ml-[16px]"}>{children}</SecondaryText>
      {select && (
        <div className="w-[39px] h-[20px] mr-[-2px] mt-[-16px]">
          <img
            src={rightView}
            style={{ width: "39px", height: "20px" }}
            alt="img"
          />
          <img
            src={rightIcon}
            alt="img"
            style={{
              width: "10px",
              height: "9px",
              marginLeft: "24px",
              marginTop: "-17px",
            }}
          />
        </div>
      )}
    </Container>
  );
}

const Container = tw.button`
h-[51px]
mt-[2px]
mb-[7px]
rounded-lg
border-2
border-[#009736]
pt-[15px]
hover:cursor-pointer
flex
flex-row
justify-between
w-full
`;

export default CourseBtn;
